import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
/**
 * 'react-app-polyfill/ie11';
 * 'react-app-polyfill/stable';
 * 보다 react가 나중에 import 되어야한다.
 * */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
